import { useMemo } from 'react';

import { useAllIndirectTaxRegistrations } from './useAllIndirectTaxRegistrations';

/** Tax-type ids the corporation already holds via an active registration. */
export function useIndirectTaxActiveTaxTypeIds({
  corporationId,
  enabled,
}: {
  corporationId: number;
  enabled: boolean;
}) {
  const {
    data: existingRegistrations,
    error,
    isLoading,
    mutate,
  } = useAllIndirectTaxRegistrations({
    filters: {
      corporationId: enabled ? corporationId : undefined,
      includeArchived: false,
    },
  });

  const activeTaxTypeIds = useMemo(() => {
    const today = new Date().toISOString().slice(0, 10);
    const ids = new Set<string>();
    (existingRegistrations ?? []).forEach((r) => {
      if (r.archivedAt) return;
      if (r.effectiveEndDate && r.effectiveEndDate < today) return;
      ids.add(r.registrationTaxTypeId);
    });
    return ids;
  }, [existingRegistrations]);

  return {
    activeTaxTypeIds,
    existingRegistrations: existingRegistrations ?? [],
    error,
    isLoading,
    mutate,
  };
}
